import { EventState, SyncEvent } from '@/types/eventhandler';
import { MigrationReport } from '@/types/migration';
import { reportChanges } from './report';

export const updateToFormat3 = (application: any, report: MigrationReport) => ({
  ...application,
  format: 3,
  syncevents: updateSyncEvents(application.syncevents, report)
});

const updateSyncEvents = (
  syncevents: Record<string, EventState> | undefined,
  report: MigrationReport
): SyncEvent[] | undefined => {
  if (!syncevents) return;
  if (syncevents.constructor === Array) return syncevents;

  const newSyncEvents: SyncEvent[] = [];
  Object.entries(syncevents).map(([synceventId, syncevent]) => {
    newSyncEvents.push({ name: synceventId, state: syncevent });
  });

  reportChanges(report, 'Sync events', 'keyed by name', 'a list of {name, state}', newSyncEvents.length);
  return newSyncEvents;
};
